/**
 * Danh sách ID định danh cho các màn hình/tính năng trong hệ thống.
 * Cần khớp với ID trả về từ API /user/info
 */
export const PERMISSION_IDS = {
  INIT: 'INIT', // Dùng cho Landing page để tự động chuyển hướng
  DASHBOARD: 'SCR_DASHBOARD',
  USER_MGT: 'SCR_USER_MGT',
  DEVICE_MGT: 'SCR_DEVICE_MGT',
  DEVICE_TYPE_MGT: 'SCR_DEVICE_TYPE_MGT',
  KPI_CAMERA: 'SCR_KPI_CAMERA',
  WAREHOUSE_MGT: 'SCR_WAREHOUSE_MGT',
  WAREHOUSE_HISTORY: 'SCR_WAREHOUSE_HISTORY',
  IMPORT_EXPORT_REPORT: 'SCR_IMPORT_EXPORT_REPORT',
  SERVICE_MGT: 'SCR_SERVICE_MGT',
  SIM_CARD_MGT: 'SCR_SIM_CARD_MGT',
  PLATFORM_FEE_MGT: 'SCR_PLATFORM_FEE_MGT',
  SYSTEM_SETTINGS: 'SCR_SYSTEM_SETTINGS',
  HR_MGT: 'SCR_HR_MGT',
  PERMISSION_GROUP_MGT: 'SCR_PERMISSION_GROUP_MGT',
  FUNCTION_PERMISSION_MGT: 'SCR_FUNCTION_PERMISSION_MGT',
  API_SETTINGS: 'SCR_API_SETTINGS',
  ACTIVITY_LOG: 'SCR_ACTIVITY_LOG',
} as const;

export type PermissionId = (typeof PERMISSION_IDS)[keyof typeof PERMISSION_IDS];
